import { Layout } from "antd"
import styles from "./index.module.less"
import DownloadSection from "./components/downloadSection"
import LowerFooter from "./components/lowerFooter"

const { Footer } = Layout

function AppFooter({ onClickMenuItem, locale }) {
  return (
    <Footer className={styles.footer}>
      <DownloadSection />
      <LowerFooter />
    </Footer>
  )
}

export default AppFooter
